<template>
  <div>
    <div class="sm:fe-hidden">
      <JdsModal @close="handleClose">
        <template #header>
          <div>
            Customer photos
            <span v-if="totalImageCount">({{ totalImageCount }})</span>
          </div>
        </template>
        <template #body>
          <InfiniteScroll
            :is-loading-data="reviewsWithImagesPageMeta.loading"
            :is-infinite-scroll="true"
            :current-page="reviewsWithImagesPageMeta.current"
            :has-next="reviewsWithImagesPageMeta.hasNext"
            @load-more="fetchMoreImages"
          >
            <div class="fe-flex fe-flex-wrap fe-justify-start fe-gap-xs">
              <LazyImage
                v-for="review in reviewDataWithImages"
                :key="review.id"
                @click="handleClick(review, review.image?.id)"
                :src="review.image?.lowResUrl"
                alt="review image"
                class-name="fe-w-[148px] fe-h-[148px] fe-rounded-xl"
              />
            </div>
          </InfiniteScroll>
        </template>
      </JdsModal>
    </div>

    <div class="lg:fe-hidden">
      <JdsSidePanel @close="handleClose">
        <template #header>
          <div>
            Customer photos
            <span v-if="totalImageCount">({{ totalImageCount }})</span>
          </div>
        </template>
        <template #body>
          <InfiniteScroll
            :is-loading-data="reviewsWithImagesPageMeta.loading"
            :is-infinite-scroll="true"
            :current-page="reviewsWithImagesPageMeta.current"
            :has-next="reviewsWithImagesPageMeta.hasNext"
            @load-more="fetchMoreImages"
          >
            <div class="fe-grid fe-grid-cols-2 fe-gap-xs fe-py-m">
              <div
                v-for="review in reviewDataWithImages"
                :key="review.id"
                @click="handleClick(review, review.image?.id)"
              >
                <LazyImage
                  :src="review.image?.lowResUrl"
                  alt="review image"
                  class-name="fe-w-full fe-h-[148px] fe-object-cover fe-rounded-xl"
                />
              </div>
            </div>
          </InfiniteScroll>
        </template>
      </JdsSidePanel>
    </div>
  </div>
</template>

<script>
  import JdsModal from "@/components/DesignSystem/JdsModal/JdsModal.vue"
  import JdsSidePanel from "@/components/DesignSystem/JdsSidePanel/JdsSidePanel.vue"
  import LazyImage from "@/components/DesignSystem/LazyImage/LazyImage.vue"
  import GalleryContentModal from "./GalleryContentModal.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import InfiniteScroll from "@/components/Utilities/InfiniteScroll/InfiniteScroll.vue"

  export default {
    name: "GalleryImageModal",
    components: {
      JdsModal,
      JdsSidePanel,
      LazyImage,
      InfiniteScroll,
    },
    mixins: [modalMixin],
    inject: ["globalState", "getProductReviewImages"], // top parent component state
    // props: {
    //   reviews: { type: Array, },
    // },
    computed: {
      reviewDataWithImages() {
        return this.globalState.reviewsWithImages
      },
      reviewsWithImagesPageMeta() {
        return this.globalState.reviewsWithImagesPageMeta || {}
      },
      totalImageCount() {
        return this.globalState.imageCount || 0
      },
    },
    methods: {
      handleClick(review, imageId) {
        if (review && imageId) {
          this.openModal(GalleryContentModal, {
            currentReview: review,
            currentImageId: imageId,
            shouldOpenImageModal: true,
          })
        }
      },
      handleClose() {
        this.$emit("close")
      },
      fetchMoreImages(pageNoToBeFetched = 0) {
        this.getProductReviewImages(pageNoToBeFetched)
      },
    },
  }
</script>
